import {
    compose,
    lifecycle
}                             from 'recompose';
import { findDOMNode }        from 'react-dom';
import EditableField          from './EditableField';
import { EditableFieldProps } from './EditableFieldTypes';
import { CustomField }        from '../../reduxTypes';

// highlight the contents of the editable span element
function selectEditableField(element: Element) {
    const range = document.createRange();
    const selection = window.getSelection();

    range.selectNodeContents(element);

    selection.removeAllRanges();
    selection.addRange(range);

    (element as HTMLElement).focus();
}

function setInnerHTML(editableField: HTMLElement, currentField: CustomField): void {
    editableField.innerHTML = currentField.editedValue || currentField.originalValue;
}

export default compose(
    lifecycle<EditableFieldProps, {}>({
        componentDidMount() {
            const component = this as any;
            const editableElement = findDOMNode(component);
            component.editableElement = editableElement;
            if (editableElement) {
                setInnerHTML((editableElement as HTMLElement), this.props.currentField);
            }
        },
        componentDidUpdate(prevProps: EditableFieldProps) {
            const fieldHasChanged = this.props.selectedField !== prevProps.selectedField;
            const isSelectedTemplate = this.props.selectedTemplate === this.props.messageTemplate.id;
            const editableField = (this as any).editableElement;
            if (prevProps.currentField.originalValue !== this.props.currentField.originalValue) {
                setInnerHTML(editableField, this.props.currentField);
            }
            // when a user changes the selected field, first make sure that field has text set for innerHTML
            // if the field is selected AND belongs to the currently selected template, highlight it so the user can enter a new value
            if (fieldHasChanged && isSelectedTemplate && this.props.selectedField === this.props.fieldName) {
                setInnerHTML(editableField, this.props.currentField);
                selectEditableField(editableField);
            } else if (fieldHasChanged && isSelectedTemplate) {
                setInnerHTML(editableField, this.props.currentField);
            }
        }
    })
)(EditableField) as React.ComponentClass<EditableFieldProps>;



// WEBPACK FOOTER //
// ./src/sections/EditableField/index.ts